(function () {
    'use strict';

    function informationPartConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/informationPartConfiguration.html',
            link: function (scope) {
            }
        };
    }

    informationPartConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('informationPartConfiguration', informationPartConfiguration);
})();

